import { render, staticRenderFns } from "./SKMatchList.vue?vue&type=template&id=6d53914f&scoped=true"
import script from "./SKMatchList.vue?vue&type=script&lang=js"
export * from "./SKMatchList.vue?vue&type=script&lang=js"
import style0 from "./SKMatchList.vue?vue&type=style&index=0&id=6d53914f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d53914f",
  null
  
)

export default component.exports